module.exports = __webpack_public_path__ + "static/media/JohnsonsBaby-Regular.48acda5d.eot";